import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `
.questionnaire-step-card {
  background: ${dt('questionnaireStep.card.background')};
  border: 1px solid ${dt('questionnaireStep.card.borderColor')};
  border-radius: ${dt('questionnaireStep.card.borderRadius')};
}

.questionnaire-step-card.active {
  background: ${dt('questionnaireStep.cardActive.background')};
  border-color: ${dt('questionnaireStep.cardActive.borderColor')};
}

/* Šoninė kortelė: balta, header uždeda savo tamsų foną — Figma 6061:21597 */
.questionnaire-step-sidebar-card {
  border-radius: 0.5rem;
  background: ${dt('content.background')};
  overflow: hidden;
}

.questionnaire-step-sidebar-card .questionnaire-step-sidebar-title {
  color: ${dt('questionnaireStep.sidebarCard.titleTextColor')};
}

.questionnaire-step-sidebar-card .questionnaire-step-sidebar-chevron {
  color: ${dt('questionnaireStep.sidebarCard.chevronColor')};
}

.questionnaire-step-sidebar-card.active {
  border-left: 2px solid ${dt('questionnaireStep.sidebarCardActiveAccent.borderLeftColor')};
}

.questionnaire-step-sidebar-card.active .questionnaire-step-sidebar-head {
  background: ${dt('questionnaireStep.sidebarCardSelected.background')};
}

.questionnaire-step-sidebar-card.active .questionnaire-step-sidebar-title {
  color: ${dt('questionnaireStep.sidebarCardSelected.titleTextColor')};
}

.questionnaire-step-sidebar-card.active .questionnaire-step-sidebar-chevron {
  color: ${dt('questionnaireStep.sidebarCardSelected.chevronColor')};
}

.questionnaire-step-sidebar-card.active .questionnaire-step-sidebar-status-question {
  color: ${dt('questionnaireStep.sidebarCardSelected.statusQuestionColor')};
}

.questionnaire-step-sidebar-card.active .questionnaire-step-progress-track {
  background: ${dt('questionnaireStep.sidebarCardSelected.progressTrackBackground')};
}

.questionnaire-step-sidebar-card:not(.active) .questionnaire-step-sidebar-status-question {
  color: ${dt('questionnaireStep.sidebarCard.statusQuestionColor')};
}

.questionnaire-step-sidebar-card:not(.active) .questionnaire-step-progress-track {
  background: ${dt('questionnaireStep.sidebarCard.progressTrackBackground')};
}

.questionnaire-step-sidebar-inner {
  width: 100%;
  min-width: 0;
}

.questionnaire-step-sidebar-head {
  min-width: 0;
  padding: 0.75rem;
  background: ${dt('questionnaireStep.sidebarCard.background')};
}

.questionnaire-step-sidebar-head-main {
  min-width: 0;
}

.questionnaire-step-sidebar-collapse-wrapper {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows ${dt('transition.duration')} ease-out;
}

.questionnaire-step-sidebar-collapse-wrapper--open {
  grid-template-rows: 1fr;
}

.questionnaire-step-sidebar-collapse-wrapper > * {
  overflow: hidden;
  min-height: 0;
}

.questionnaire-step-sidebar-expanded-body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.questionnaire-step-sidebar-expanded-body > * {
  padding-left: 1rem;
  padding-right: 1rem;
}

.questionnaire-step-sidebar-expanded-body > *:first-child {
  padding-top: 1rem;
}

.questionnaire-step-sidebar-expanded-body > *:last-child {
  padding-bottom: 0.5rem;
}

.questionnaire-step-sidebar-status-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
}

.questionnaire-step-sidebar-status-question {
  color: ${dt('questionnaireStep.activityPanel.labelColor')};
  font-size: 0.875rem;
  line-height: 1.5rem;
  font-weight: 400;
}

/* Sidebar status: pilkas segmentų fonas + pasirinktas — balta „tabletė“ viduje (Figma principas) */
.questionnaire-step-sidebar-expanded-body .p-selectbutton {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  display: flex;
  gap: 0;
  padding: 4px;
  border: 1px solid ${dt('surface.100')};
  border-radius: 6px;
  background: ${dt('surface.100')};
  overflow: hidden;
  box-sizing: border-box;
}

.questionnaire-step-sidebar-expanded-body .p-selectbutton .p-togglebutton {
  flex: 1 1 0;
  border: none;
  background: transparent;
  color: ${dt('named.questionnaire.status.segment.color')};
  min-width: 0;
  padding: 0;
  border-radius: 0;
  font-weight: 600;
  line-height: 24px;
  box-shadow: none;
}

.questionnaire-step-sidebar-expanded-body .p-selectbutton .p-togglebutton:last-child {
  flex: 1 1 0;
}

.questionnaire-step-sidebar-expanded-body .p-selectbutton .p-togglebutton.p-togglebutton-checked {
  background: transparent;
  color: ${dt('surface.900')};
  font-weight: 600;
  box-shadow: none;
}

.questionnaire-step-sidebar-expanded-body .p-selectbutton .p-togglebutton .p-togglebutton-content {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-width: 0;
  gap: 6px;
  padding: 3px 6px;
  border-radius: 6px;
  box-sizing: border-box;
  background: transparent;
  box-shadow: none;
}

.questionnaire-step-sidebar-expanded-body .p-selectbutton .p-togglebutton.p-togglebutton-checked .p-togglebutton-content {
  background: ${dt('surface.0')};
  color: ${dt('surface.900')};
  font-weight: 600;
  box-shadow: none;
}

.questionnaire-step-sidebar-expanded-body .p-selectbutton .p-togglebutton .p-button-label {
  white-space: nowrap;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
}

/* Custom item šablonas — ne visada gauna .p-button-label taisykles; sulygiuojame su nepasirinkta būsena */
.questionnaire-step-sidebar-expanded-body .p-selectbutton .p-togglebutton .questionnaire-step-status-option-content {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 0;
  max-width: 100%;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.25rem;
  color: inherit;
}

.questionnaire-step-sidebar-expanded-body .p-selectbutton .p-togglebutton .questionnaire-step-status-option-content span:last-child {
  white-space: nowrap;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.25rem;
  min-width: 0;
}

.questionnaire-step-status-readonly {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  display: flex;
  gap: 0;
  padding: 4px;
  border: 1px solid ${dt('surface.100')};
  border-radius: 6px;
  background: ${dt('surface.100')};
  overflow: hidden;
  box-sizing: border-box;
}

.questionnaire-step-status-readonly-option {
  flex: 1 1 0;
  border: none;
  background: transparent;
  color: ${dt('named.questionnaire.status.segment.color')};
  min-width: 0;
  padding: 0;
  border-radius: 0;
  box-sizing: border-box;
  cursor: default;
}

.questionnaire-step-status-readonly-option:last-child {
  border-right-width: 0;
}

.questionnaire-step-status-readonly-option .questionnaire-step-status-option-content {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 0;
  max-width: 100%;
  width: 100%;
  padding: 3px 6px;
  border-radius: 6px;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.25rem;
  color: inherit;
}

.questionnaire-step-status-readonly-option .questionnaire-step-status-option-content span:last-child {
  white-space: nowrap;
}

.questionnaire-step-status-readonly-option.is-selected {
  background: transparent;
  color: ${dt('surface.900')};
}

.questionnaire-step-status-readonly-option.is-selected .questionnaire-step-status-option-content {
  background: ${dt('surface.0')};
  color: ${dt('surface.900')};
}

/*
 * Kai būsena „Tikrinta“ ir yra atsakymų, „Netaikoma“ išjungta (optionDisabled).
 * Prime .p-disabled kitaip nudažo segmentą — ant tamsios aktyvios kortelės atrodo neproporcingai tamsiai.
 * Suvienodiname su kitais nepažymėtais segmentais (surface.100 / named.questionnaire.status.segment.color).
 */
.questionnaire-step-sidebar-card .questionnaire-step-sidebar-expanded-body .p-selectbutton .p-togglebutton.p-disabled,
.questionnaire-step-sidebar-card .questionnaire-step-sidebar-expanded-body .p-selectbutton .p-togglebutton.p-disabled:hover {
  background: transparent;
  border: none;
  color: ${dt('named.questionnaire.status.segment.color')};
  opacity: 1;
  cursor: not-allowed;
}

.questionnaire-step-sidebar-card .questionnaire-step-sidebar-expanded-body .p-selectbutton .p-togglebutton.p-disabled:not(.p-togglebutton-checked) .p-togglebutton-content {
  background: transparent;
  opacity: 1;
}

.questionnaire-step-sidebar-card .questionnaire-step-sidebar-expanded-body .p-selectbutton .p-togglebutton.p-disabled.p-togglebutton-checked .p-togglebutton-content {
  background: ${dt('surface.0')};
  opacity: 1;
}

.questionnaire-step-status-option-icon {
  font-size: 12px;
  line-height: 12px;
  color: currentColor;
}

.questionnaire-step-sidebar-title-typography {
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.25rem;
}

.questionnaire-step-sidebar-title-collapsed {
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.5rem;
}

/* VMVT Figma 6061:21306 chevron-circle-* — apskritimas + chevron vienoje SVG, be atskiro CSS rėmelio */
.questionnaire-step-sidebar-card .questionnaire-step-sidebar-chevron {
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  min-width: 2rem;
  min-height: 2rem;
  box-sizing: border-box;
  padding: 0;
  border: none;
  border-radius: 0;
  background: transparent;
}

.questionnaire-step-sidebar-card .questionnaire-step-sidebar-chevron-icon {
  font-size: 1rem;
  line-height: 1;
  width: 2rem;
  height: 2rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 2px solid currentColor;
  border-radius: 9999px;
  box-sizing: border-box;
}

.questionnaire-step-sidebar-card .questionnaire-step-sidebar-chevron-icon {
  transition: transform ${dt('transition.duration')} ease-out;
}

.questionnaire-step-sidebar-card .questionnaire-step-sidebar-chevron-icon-expanded {
  transform: rotate(90deg);
}

.questionnaire-step-header-box {
  background: ${dt('questionnaireStep.header.background')};
  color: ${dt('questionnaireStep.header.textColor')};
  font-weight: ${dt('questionnaireStep.header.fontWeight')};
}

.questionnaire-step-muted {
  color: ${dt('questionnaireStep.mutedTextColor')};
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.questionnaire-step-activity-panel-bg .questionnaire-step-muted {
  font-size: 0.75rem;
  line-height: 1rem;
}

.questionnaire-step-primary-text {
  color: ${dt('questionnaireStep.primaryTextColor')};
}

.questionnaire-step-activity-accordion .p-accordionheader {
  border-bottom: 1px solid ${dt('questionnaireStep.activityAccordion.headerBorderBottomColor')};
  padding: 0.75rem 0.5rem;
  background: ${dt('questionnaireStep.activityAccordion.headerBackground')};
}

.questionnaire-step-activity-accordion .p-accordionpanel > .p-accordionheader,
.questionnaire-step-activity-accordion .p-accordionpanel.p-accordionpanel-active > .p-accordionheader {
  background: ${dt('questionnaireStep.activityAccordion.headerBackground')} !important;
  border-radius: 0 !important;
}

.questionnaire-step-activity-accordion .p-accordionpanel > .p-accordionheader .p-accordionheader-link,
.questionnaire-step-activity-accordion .p-accordionpanel.p-accordionpanel-active > .p-accordionheader .p-accordionheader-link {
  background: ${dt('questionnaireStep.activityAccordion.headerBackground')};
  border-radius: 0 !important;
  box-shadow: none !important;
}

.questionnaire-step-activity-accordion .p-accordionpanel > .p-accordionheader:hover,
.questionnaire-step-activity-accordion .p-accordionpanel.p-accordionpanel-active > .p-accordionheader:hover,
.questionnaire-step-activity-accordion .p-accordionpanel > .p-accordionheader:focus-within,
.questionnaire-step-activity-accordion .p-accordionpanel.p-accordionpanel-active > .p-accordionheader:focus-within {
  background: ${dt('questionnaireStep.activityAccordion.headerBackground')} !important;
}

.questionnaire-step-activity-accordion .p-accordionpanel > .p-accordionheader .p-accordionheader-link:hover,
.questionnaire-step-activity-accordion .p-accordionpanel.p-accordionpanel-active > .p-accordionheader .p-accordionheader-link:hover,
.questionnaire-step-activity-accordion .p-accordionpanel > .p-accordionheader .p-accordionheader-link:focus,
.questionnaire-step-activity-accordion .p-accordionpanel.p-accordionpanel-active > .p-accordionheader .p-accordionheader-link:focus,
.questionnaire-step-activity-accordion .p-accordionpanel > .p-accordionheader .p-accordionheader-link:active,
.questionnaire-step-activity-accordion .p-accordionpanel.p-accordionpanel-active > .p-accordionheader .p-accordionheader-link:active {
  background: ${dt('questionnaireStep.activityAccordion.headerBackground')} !important;
}

.questionnaire-step-activity-accordion-title {
  color: ${dt('questionnaireStep.activityAccordion.headerTitleColor')};
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.5rem;
}

.questionnaire-step-activity-accordion .p-accordionheader-toggle-icon {
  color: ${dt('questionnaireStep.activityAccordion.headerToggleIconColor')} !important;
  font-size: 0.875rem;
  width: 0.875rem;
  height: 0.875rem;
  min-width: 0.875rem;
  line-height: 0.875rem;
  opacity: 1 !important;
  visibility: visible !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
}

.questionnaire-step-activity-accordion .p-accordionheader-toggle-icon .p-icon,
.questionnaire-step-activity-accordion .p-accordionheader-toggle-icon svg {
  width: 0.875rem;
  height: 0.875rem;
  color: ${dt('questionnaireStep.activityAccordion.headerToggleIconColor')} !important;
  fill: currentColor !important;
  stroke: currentColor !important;
  opacity: 1 !important;
  visibility: visible !important;
}

.questionnaire-step-activity-accordion .p-accordioncontent-content {
  padding: 0 !important;
}

.questionnaire-step-activity-accordion-toggle-icon {
  color: ${dt('questionnaireStep.activityAccordion.headerToggleIconColor')} !important;
  font-size: 0.875rem;
  width: 0.875rem;
  height: 0.875rem;
  line-height: 0.875rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.questionnaire-step-layout-toggle-icon {
  font-size: 0.875rem;
  width: 0.875rem;
  height: 0.875rem;
  line-height: 0.875rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.questionnaire-step-layout-toggle-icon-collapsed {
  transform: rotate(180deg);
}

.questionnaire-step-activity-panel-bg {
  background: ${dt('questionnaireStep.activityPanel.background')};
}

.questionnaire-step-activity-label {
  color: ${dt('questionnaireStep.activityPanel.labelColor')};
  font-size: 0.75rem;
  line-height: 1.125rem;
  font-weight: 400;
}

.questionnaire-step-activity-title {
  color: ${dt('questionnaireStep.activityPanel.activityTitleColor')};
  font-size: 0.875rem;
  line-height: 1.5rem;
  font-weight: 600;
}

.questionnaire-step-activity-code {
  color: ${dt('questionnaireStep.activityPanel.activityCodeColor')};
}

.questionnaire-step-activity-list {
  color: ${dt('questionnaireStep.activityPanel.goalTextColor')};
  font-size: 0.875rem;
  line-height: 1.5rem;
  font-weight: 400;
}

.questionnaire-step-control-button {
  background: transparent;
  border: 0;
  color: ${dt('questionnaireStep.controlButton.textColor')};
  border-radius: 0;
  font-size: 0.75rem;
  line-height: 1rem;
}

.questionnaire-step-control-button:disabled {
  color: ${dt('text.muted.color')};
  cursor: not-allowed;
  opacity: 0.6;
}

.questionnaire-requirement-search-overlay {
  background: ${dt('questionnaireStep.searchOverlay.background')};
  border: 1px solid ${dt('questionnaireStep.searchOverlay.borderColor')};
  min-width: 100%;
  width: max-content;
  max-width: 56rem;
}

.questionnaire-requirement-search-select .p-select {
  width: 40rem;
  max-width: 100%;
  border-radius: 0.375rem;
  box-shadow: ${dt('questionnaireStep.searchSelect.shadow')};
  font-size: 0.875rem;
  line-height: 1.5rem;
}

.questionnaire-requirement-search-select .p-select-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.questionnaire-requirement-search-header {
  padding: 0.5625rem 0.25rem 0.25rem;
  font-size: 0.875rem;
  line-height: 1.5rem;
  color: ${dt('surface.400')};
}

.questionnaire-requirement-search-option {
  border-bottom: 0;
  border-radius: 4px;
  background: transparent;
  color: ${dt('select.option.color')};
  font-size: 0.875rem;
  line-height: 1.5rem;
  width: 100%;
  box-sizing: border-box;
  min-width: 0;
  overflow: hidden;
}

.questionnaire-requirement-search-option-text {
  display: block;
  white-space: normal;
  word-break: break-word;
}

.questionnaire-requirement-search-option:hover {
  background: ${dt('primary.50')};
  color: ${dt('primary.400')};
}

.questionnaire-requirement-search-overlay .p-select-list {
  background: ${dt('surface.0')};
}

.questionnaire-requirement-search-overlay .p-select-option {
  padding: 0 !important;
  background: transparent !important;
  overflow: hidden;
  min-width: 0;
}

.questionnaire-requirement-search-overlay .p-select-option:hover,
.questionnaire-requirement-search-overlay .p-select-option.p-focus,
.questionnaire-requirement-search-overlay .p-select-option.p-select-option-selected {
  background: transparent !important;
}

.questionnaire-requirement-search-overlay .p-select-option.p-focus .questionnaire-requirement-search-option,
.questionnaire-requirement-search-overlay .p-select-option.p-select-option-selected .questionnaire-requirement-search-option {
  background: ${dt('primary.50')};
  color: ${dt('primary.400')};
}

.questionnaire-step-empty-result {
  background: ${dt('questionnaireStep.emptyState.background')};
  border: 1px solid ${dt('questionnaireStep.emptyState.borderColor')};
  color: ${dt('questionnaireStep.emptyState.textColor')};
  border-radius: 0.375rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.questionnaire-step-empty-result-hero {
  background: ${dt('content.background')};
  border: 1px solid ${dt('content.border.color')};
  padding-top: 0.75rem;
}

.questionnaire-step-empty-dashed {
  border: 1px dashed ${dt('questionnaireStep.dashedEmptyState.borderColor')};
  color: ${dt('questionnaireStep.dashedEmptyState.textColor')};
  border-radius: 0.5rem;
}

.questionnaire-step-not-applicable-hero {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  background: ${dt('surface.0')};
}

.questionnaire-step-not-applicable-hero-art {
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  display: block;
  object-fit: contain;
}

.questionnaire-step-not-applicable-intro {
  padding: 0 1rem;
}

/* Figma 5964:156698 — Body/Body 30 */
.questionnaire-step-not-applicable-intro-body {
  margin: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.625rem;
  color: ${dt('surface.600')};
}

.questionnaire-step-not-applicable-note-label {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.375rem;
}

.questionnaire-step-not-applicable-optional-hint {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;
  color: ${dt('surface.400')};
}

.questionnaire-step-not-applicable-transfer-row {
  display: flex;
  align-items: flex-start;
  gap: 0.625rem;
}

.questionnaire-step-not-applicable-checkbox-label {
  font-size: 1rem;
  line-height: 1.5rem;
  color: ${dt('questionnaireStep.primaryTextColor')};
  cursor: pointer;
  padding-top: 0.125rem;
}

.questionnaire-step-editor-not-applicable-stack {
  margin-top: 0.75rem;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 1.25rem;
  min-height: 0;
  background: ${dt('surface.0')};
  padding-bottom: ${dt('questionnaireStep.contentPaddingInline')};
}

/* Figma 5964:156698 — Title/Title 40 (18px / 30px, primary.500) */
.questionnaire-step-not-applicable-hero-title {
  color: ${dt('primary.500')};
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.875rem;
}

.questionnaire-step-not-applicable-form-head-title {
  color: ${dt('primary.500')};
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.875rem;
}

.questionnaire-step-not-applicable-form-actions {
  display: flex;
  justify-content: flex-end;
}

.questionnaire-step-editor-not-checked-root {
  margin-top: 0.75rem;
}

.questionnaire-step-editor-not-checked-card {
  padding: 1rem;
  border-radius: 0.5rem;
}

.questionnaire-step-editor-not-checked-lead {
  color: ${dt('questionnaireStep.mutedTextColor')};
  font-size: 0.875rem;
  line-height: 1.5rem;
}

.questionnaire-step-editor-not-checked-fields {
  margin-top: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.questionnaire-step-editor-not-checked-label {
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.5rem;
  color: ${dt('questionnaireStep.mutedTextColor')};
}

.questionnaire-step-editor-not-checked-actions {
  margin-top: 0.75rem;
  display: flex;
  justify-content: flex-end;
}

.questionnaire-step-additional-info-actions {
  display: flex;
  justify-content: flex-end;
}

.questionnaire-step-question-note-panel {
  margin-top: 1.5rem;
}

.questionnaire-step-note-panel-heading {
  margin-bottom: 0.875rem;
}

.questionnaire-step-note-panel-checkbox-wrap {
  margin-top: 1rem;
}

.questionnaire-step-note-panel-upload-wrap {
  margin-top: 1.5rem;
}

.questionnaire-step-note-panel-upload-inner {
  margin-top: 1rem;
}

.questionnaire-step-note-panel-actions {
  margin-top: 1.5rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.questionnaire-step-note-panel-hint {
  margin-top: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.questionnaire-step-not-applicable-form {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${dt('questionnaireStep.notApplicableForm.sectionGap')};
  border: 1px solid ${dt('questionnaireStep.notApplicableForm.borderColor')};
  border-radius: ${dt('questionnaireStep.notApplicableForm.borderRadius')};
  padding: ${dt('questionnaireStep.notApplicableForm.padding')};
  background: ${dt('surface.0')};
}

.questionnaire-step-not-applicable-form-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  box-sizing: border-box;
  padding: ${dt('questionnaireStep.notApplicableForm.headPadding')};
  background: ${dt('questionnaireStep.notApplicableForm.headBackground')};
}

.questionnaire-step-not-applicable-form-fields {
  display: flex;
  flex-direction: column;
  gap: ${dt('questionnaireStep.notApplicableForm.fieldsGap')};
  width: 100%;
  align-self: stretch;
}

/* Figma 5964:158957 — info 24×24; taikoma visiems info ikonų naudojimams šiame žingsnyje */
.questionnaire-step-info-icon-24 {
  box-sizing: border-box;
  width: 1.5rem;
  height: 1.5rem;
  font-size: 1.125rem;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.questionnaire-step-not-applicable-form-head .questionnaire-step-info-icon-24,
.questionnaire-step-additional-info-banner .questionnaire-step-info-icon-24 {
  color: ${dt('primary.500')};
  margin-top: 0.125rem;
}

.questionnaire-step-question-header .questionnaire-step-info-icon-24 {
  margin-top: 0;
}

/* Figma 5964:158957 — įkėlimo zona tame pačiame žingsnyje: ta pati 24×24 skalė kaip info */
.questionnaire-step-scope .file-upload-zone-icon {
  font-size: 1.5rem;
  line-height: 1;
}

.questionnaire-step-not-applicable-form-body {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${dt('questionnaireStep.notApplicableForm.bodySectionGap')};
  padding-inline: ${dt('questionnaireStep.notApplicableForm.bodyPaddingInline')};
  width: 100%;
  box-sizing: border-box;
}

.questionnaire-step-not-applicable-form-body .questionnaire-step-not-applicable-saved-row {
  align-self: stretch;
}

.questionnaire-step-not-applicable-form .questionnaire-step-note-textarea {
  border: 1px solid ${dt('surface.100')};
  border-radius: 0.375rem;
}

.questionnaire-step-not-applicable-saved-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

.questionnaire-step-not-applicable-saved-note {
  flex: 1 1 auto;
  min-width: 0;
}

.questionnaire-step-not-applicable-saved-meta {
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: ${dt('text.muted.color')};
}

.questionnaire-step-additional-info-root {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.questionnaire-step-additional-info-panel {
  border: 1px solid ${dt('surface.100')};
  background: ${dt('surface.0')};
  border-radius: 4px;
  overflow: hidden;
}

.questionnaire-step-additional-info-banner {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.75rem;
  background: ${dt('primary.50')};
}

.questionnaire-step-additional-info-banner-title {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.25rem;
  color: ${dt('primary.500')};
}

.questionnaire-step-additional-info-text-inner {
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  padding: 1.5rem 1rem 1.5rem;
}

.questionnaire-step-additional-info-field {
  display: flex;
  flex-direction: column;
  gap: 0.875rem;
}

.questionnaire-step-additional-info-upload-body {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1.5rem 1rem 1.5rem;
}

.questionnaire-step-additional-info-upload-intro {
  margin: 0;
  color: ${dt('surface.400')};
  font-size: 1rem;
  line-height: 1.625rem;
  font-weight: 400;
}

.questionnaire-step-additional-info-upload-slot {
  width: 100%;
}

.questionnaire-step-divider {
  border-bottom: 1px solid ${dt('questionnaireStep.divider.borderColor')};
}

.questionnaire-step-result-button {
  border: 1px solid ${dt('questionnaireStep.resultButton.borderColor')};
  background: ${dt('questionnaireStep.resultButton.background')};
  color: ${dt('questionnaireStep.resultButton.textColor')};
  border-radius: 0.375rem;
  min-height: 3.125rem;
  padding: 0.6875rem 0.65625rem;
  font-size: 1rem;
  line-height: 1.625rem;
  font-weight: 400;
}

.questionnaire-step-result-button.is-yes {
  border-color: ${dt('questionnaireStep.resultYes.borderColor')};
  background: ${dt('questionnaireStep.resultYes.background')};
  color: ${dt('questionnaireStep.resultYes.textColor')};
  font-weight: 500;
}

.questionnaire-step-result-button.is-no {
  border-color: ${dt('questionnaireStep.resultNo.borderColor')};
  background: ${dt('questionnaireStep.resultNo.background')};
  color: ${dt('questionnaireStep.resultNo.textColor')};
  font-weight: 500;
}

.questionnaire-step-result-button.is-not-checked {
  border-color: ${dt('questionnaireStep.resultNotChecked.borderColor')};
  background: ${dt('questionnaireStep.resultNotChecked.background')};
  color: ${dt('questionnaireStep.resultNotChecked.textColor')};
  font-weight: 500;
}

.questionnaire-step-number-badge {
  cursor: pointer;
  border: 0;
  border-radius: 2px;
  background: ${dt('primary.50')};
  color: ${dt('surface.900')};
  font-size: 1rem;
  line-height: 1.625rem;
}

.questionnaire-step-number-badge.state-default.is-in-viewport {
  background: ${dt('primary.100')};
}

.questionnaire-step-number-badge.state-default.is-selected {
  background: ${dt('primary.200')};
}

.questionnaire-step-number-badge.state-default:not(.is-disabled):not(.is-selected):hover {
  background: ${dt('primary.100')};
}


.questionnaire-step-number-badge.state-yes {
  background: ${dt('green.400')};
  color: ${dt('surface.900')};
}

.questionnaire-step-number-badge.state-yes.is-in-viewport {
  background: ${dt('green.500')};
}

.questionnaire-step-number-badge.state-yes.is-selected {
  background: ${dt('green.600')};
}

.questionnaire-step-number-badge.state-yes:not(.is-disabled):not(.is-selected):hover {
  background: ${dt('green.500')};
}


.questionnaire-step-number-badge.state-no {
  background: ${dt('red.400')};
  color: ${dt('surface.900')};
}

.questionnaire-step-number-badge.state-no.is-in-viewport {
  background: ${dt('red.500')};
}

.questionnaire-step-number-badge.state-no.is-selected {
  background: ${dt('red.600')};
}

.questionnaire-step-number-badge.state-no:not(.is-disabled):not(.is-selected):hover {
  background: ${dt('red.500')};
}


.questionnaire-step-number-badge.state-not-checked {
  background: ${dt('yellow.300')};
  color: ${dt('surface.900')};
}

.questionnaire-step-number-badge.state-not-checked.is-in-viewport {
  background: ${dt('yellow.500')};
}

.questionnaire-step-number-badge.state-not-checked.is-selected {
  background: ${dt('yellow.600')};
}

.questionnaire-step-number-badge.state-not-checked:not(.is-disabled):not(.is-selected):hover {
  background: ${dt('yellow.500')};
}


.questionnaire-step-number-badge.state-note-only {
  background: ${dt('orange.300')};
  color: ${dt('surface.900')};
}

.questionnaire-step-number-badge.state-note-only.is-in-viewport {
  background: ${dt('orange.500')};
}

.questionnaire-step-number-badge.state-note-only.is-selected {
  background: ${dt('orange.600')};
}

.questionnaire-step-number-badge.state-note-only:not(.is-disabled):not(.is-selected):hover {
  background: ${dt('orange.500')};
}


.questionnaire-step-number-badge.is-disabled {
  color: ${dt('surface.200')};
  cursor: not-allowed;
  opacity: 1;
}

.questionnaire-step-number-badge.state-default.is-disabled {
  background: ${dt('surface.100')};
}

.questionnaire-step-number-badge.state-yes.is-disabled {
  background: ${dt('green.100')};
}

.questionnaire-step-number-badge.state-no.is-disabled {
  background: ${dt('red.100')};
}

.questionnaire-step-number-badge.state-not-checked.is-disabled {
  background: ${dt('yellow.100')};
}

.questionnaire-step-number-badge.state-note-only.is-disabled {
  background: ${dt('orange.100')};
}


.questionnaire-step-question-card {
  scroll-margin-top: var(--questionnaire-scroll-anchor-offset, 0px);
}

/* Keep the additional-info anchor clear of the sticky header on scroll-into-view. */
#questionnaire-additional-info-anchor {
  scroll-margin-top: var(--questionnaire-scroll-anchor-offset, 0px);
}

.questionnaire-step-question-card.is-yes,
.questionnaire-step-additional-info-panel.is-yes {
  border-color: ${dt('questionnaireStep.cardState.yesBorderColor')};
}

.questionnaire-step-question-card.is-no {
  border-color: ${dt('questionnaireStep.cardState.noBorderColor')};
}

.questionnaire-step-question-card.is-not-checked {
  border-color: ${dt('questionnaireStep.cardState.notCheckedBorderColor')};
}

.questionnaire-step-question-card.is-note-only {
  border-color: ${dt('questionnaireStep.cardState.noteOnlyBorderColor')};
}

.questionnaire-step-question-card.is-locked {
  opacity: 0.6;
  cursor: not-allowed;
}

.questionnaire-step-question-card.is-locked > *:not(app-question-lock-popover) {
  pointer-events: none;
}

.questionnaire-step-question-header {
  background: ${dt('questionnaireStep.questionHeader.background')};
  color: ${dt('questionnaireStep.questionHeader.textColor')};
}

.questionnaire-step-question-header.is-locked {
  background: ${dt('surface.200')};
  color: ${dt('primary.500')};
}

.questionnaire-step-question-title {
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.25rem;
}

.questionnaire-step-question-note {
  background: ${dt('questionnaireStep.questionNote.background')};
  border: 1px solid ${dt('questionnaireStep.questionNote.borderColor')};
  color: ${dt('questionnaireStep.questionNote.textColor')};
  border-radius: 0.375rem;
  box-shadow: ${dt('questionnaireStep.questionNote.shadow')};
}

.questionnaire-step-question-note-text {
  font-size: 1rem;
  line-height: 1.625rem;
}

.questionnaire-step-question-note-label {
  color: ${dt('questionnaireStep.questionNote.labelColor')};
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.25rem;
  margin-right: 0.25rem;
}

/* R4 — sutraukta pastaba kortelėje: viena eilutė su daugtaškiu */
.questionnaire-step-question-note-text--collapsed {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* R1 — failų indikatorius kortelėje (Figma: gray/300, 14px) */
.questionnaire-step-question-file-indicator {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  color: ${dt('surface.300')};
  font-size: 0.875rem;
  line-height: 1.5rem;
}

.questionnaire-step-question-file-indicator .pi {
  font-size: 1rem;
  line-height: 1.5rem;
  flex-shrink: 0;
}

.questionnaire-step-note-field-label {
  display: inline-flex;
  align-items: baseline;
  gap: 0.25rem;
  color: ${dt('surface.900')};
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.625rem;
}

.questionnaire-step-note-required-star {
  color: ${dt('red.500')};
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.375rem;
}

.questionnaire-step-note-field-label-required {
  font-weight: 600;
  line-height: 1.5rem;
}

.questionnaire-step-note-optional-hint {
  color: ${dt('surface.200')};
  font-weight: 400;
}

.questionnaire-step-note-legislation-select .p-multiselect-label {
  font-size: 1.125rem;
  line-height: 1.875rem;
}

.questionnaire-step-note-legislation-select .p-multiselect-label.p-placeholder {
  color: ${dt('surface.300')};
}

.questionnaire-step-note-legislation-select .p-multiselect {
  min-height: 3rem;
}

.questionnaire-step-note-textarea {
  width: 100%;
  box-sizing: border-box;
  font-size: 1rem;
  line-height: 1.625rem;
}

.questionnaire-step-note-textarea::placeholder {
  color: ${dt('surface.300')};
}

.questionnaire-step-note-checkbox-row {
  display: inline-flex;
  align-items: center;
  gap: 0.4375rem;
}

.questionnaire-step-note-checkbox .p-checkbox-box {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 0.25rem;
}

.questionnaire-step-note-checkbox-label {
  color: ${dt('surface.900')};
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.625rem;
}

.questionnaire-step-note-upload-title {
  color: ${dt('surface.900')};
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.875rem;
}

.questionnaire-step-progress-track {
  background: ${dt('questionnaireStep.progress.trackBackground')};
  border-radius: 0.375rem;
}

.questionnaire-step-progress-value {
  background: ${dt('questionnaireStep.progress.valueBackground')};
  color: ${dt('questionnaireStep.progress.valueTextColor')};
  font-size: 0.65625rem;
  font-weight: 600;
  line-height: normal;
}

.questionnaire-step-progress-value-empty {
  background: transparent;
}

.questionnaire-step-sidebar-progress {
  position: relative;
}

.questionnaire-step-sidebar-progress .p-progressbar {
  height: 18px;
}

.questionnaire-step-sidebar-progress .p-progressbar-value {
  background: ${dt('questionnaireStep.progress.valueBackground')};
}

/* Own label overlaid across the whole bar — Optimus renders its label inside the
   fill, so it gets clipped at low / zero values. */
.questionnaire-step-sidebar-progress-label {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${dt('questionnaireStep.progress.valueTextColor')};
  font-size: 0.75rem;
  font-weight: 600;
  pointer-events: none;
}

.questionnaire-step-editor-header {
  display: block;
  background: ${dt('questionnaireStep.editorHeader.background')};
  padding: ${dt('questionnaireStep.editorHeader.paddingBlock')} ${dt('questionnaireStep.editorHeader.paddingInline')};
}


.questionnaire-step-editor-header-title {
  color: ${dt('questionnaireStep.editorHeader.titleTextColor')};
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.75rem;
  word-break: break-word;
}

.questionnaire-step-layout-toggle {
  width: 2rem;
  height: 2rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  color: ${dt('surface.0')};
  cursor: pointer;
  padding: 0;
}

.questionnaire-step-toolbar-panel {
  display: flex;
  flex-direction: column;
  background: ${dt('questionnaireStep.toolbarPanel.background')};
  padding-top: calc(${dt('questionnaireStep.toolbarPanel.edgeGap')} + ${dt('questionnaireStep.toolbarPanel.edgeInset')});
  padding-bottom: calc(${dt('questionnaireStep.toolbarPanel.edgeGap')} + ${dt('questionnaireStep.toolbarPanel.edgeInset')});
}

.questionnaire-step-toolbar-panel > app-questionnaire-toolbar {
  display: flex;
  flex-direction: column;
  gap: ${dt('questionnaireStep.toolbarPanel.sectionGap')};
  width: 100%;
  min-width: 0;
}

.questionnaire-step-toolbar-search {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
  gap: 0.75rem;
}

.questionnaire-step-filter-wrap {
  box-sizing: border-box;
  width: auto;
  background: ${dt('questionnaireStep.filterBar.background')};
  border-radius: 0.5rem;
  padding-inline: ${dt('questionnaireStep.filterBar.paddingInline')};
  padding-block: ${dt('questionnaireStep.filterBar.paddingBlock')};
}

.questionnaire-step-filter-title {
  color: ${dt('questionnaireStep.filterTitle.textColor')};
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.625rem;
}

.questionnaire-step-filter-tag {
  background: ${dt('questionnaireStep.filterTag.background')};
  color: ${dt('questionnaireStep.filterTag.textColor')};
  border-radius: ${dt('questionnaireStep.filterTag.borderRadius')};
  border: 0;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.5rem;
  padding: 0.21875rem 0.4375rem;
  cursor: pointer;
}

.questionnaire-step-filter-tag.active {
  background: ${dt('questionnaireStep.filterTag.activeBackground')};
  color: ${dt('questionnaireStep.filterTag.activeTextColor')};
}

.questionnaire-step-filter-checkbox-label {
  color: ${dt('questionnaireStep.filterCheckbox.textColor')};
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5rem;
}

.questionnaire-step-filter-checkbox-row {
  gap: 0.4375rem;
}

.questionnaire-step-filter-checkbox .p-checkbox-box {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 0.25rem;
  background: ${dt('questionnaireStep.filterCheckbox.boxBackground')};
  border: 1px solid ${dt('questionnaireStep.filterCheckbox.boxBorderColor')};
}

.questionnaire-step-editor-surface {
  background: ${dt('surface.0')};
}

.questionnaire-step-editor-surface .questionnaire-step-editor-header,
.questionnaire-step-editor-surface .questionnaire-step-toolbar-panel,
.questionnaire-step-editor-surface .questionnaire-step-viewport-wrap,
.questionnaire-step-editor-surface .questionnaire-step-editor-not-applicable-stack {
  padding-inline: ${dt('questionnaireStep.contentPaddingInline')};
}

.questionnaire-step-sticky-zone {
  position: sticky;
  top: calc(${dt('questionnaireStep.sticky.topOffset')} + 8px);
  z-index: calc(${dt('questionnaireStep.sticky.zIndex')} - 1);
  isolation: isolate;
  background: ${dt('surface.0')};
  overflow: hidden;
}

/* Sticky zonoje viršus tiesus, kad neliktų "sulindimo" efekto. */

.questionnaire-step-sidebar-sticky app-questionnaire-sidebar-card:first-child .questionnaire-step-sidebar-card {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.questionnaire-step-sidebar-sticky {
  position: sticky;
  top: calc(${dt('questionnaireStep.sticky.topOffset')} + 8px);
  max-height: ${dt('questionnaireStep.sticky.sidebarMaxHeight')};
  overflow-y: hidden;
  overflow-x: hidden;
  overscroll-behavior: contain;
  scrollbar-gutter: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.questionnaire-step-sidebar-sticky:hover,
.questionnaire-step-sidebar-sticky:focus,
.questionnaire-step-sidebar-sticky:focus-within {
  overflow-y: auto;
}

.questionnaire-step-page-root {
  min-height: 0;
}

.questionnaire-step-scope {
  min-height: 0;
  flex: 1;
}

.questionnaire-step-sidebar-layout {
  grid-template-columns: 0px minmax(0, 1fr);
  column-gap: 0;
  transition: grid-template-columns ${dt('transition.duration')} ease-out,
              column-gap ${dt('transition.duration')} ease-out;
}

.questionnaire-step-sidebar-layout--open {
  grid-template-columns: 24rem minmax(0, 1fr);
  column-gap: ${dt('questionnaireStep.sidebarLayoutColumnGap')};
}

.questionnaire-step-sidebar-layout-aside {
  overflow: hidden;
  min-width: 0;
  visibility: hidden;
}

.questionnaire-step-sidebar-layout:not(.questionnaire-step-sidebar-layout--open) .questionnaire-step-sidebar-layout-aside {
  width: 0;
  padding: 0;
}

.questionnaire-step-sidebar-layout--open .questionnaire-step-sidebar-layout-aside {
  visibility: visible;
}

.questionnaire-step-main-scroll {
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

/* Editorius turi užpildyti visą main-scroll aukštį */
.questionnaire-step-main-scroll > app-questionnaire-editor {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* Viewport wrapper (div.mt-3 aplink klausimų sąrašą) — atskiras wrapper, kad būtų galima flex: 1 */
.questionnaire-step-viewport-wrap {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding-bottom: ${dt('questionnaireStep.contentPaddingInline')};
}

.questionnaire-step-list-viewport {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.questionnaire-step-list-flow {
  position: relative;
  z-index: 0;
  flex: 1;
  min-height: 320px;
  overflow: visible;
}

.questionnaire-step-sidebar-sticky::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.questionnaire-step-sidebar-sticky::-webkit-scrollbar-thumb {
  background: transparent;
}

.questionnaire-step-sidebar-sticky::-webkit-scrollbar-track {
  background: transparent;
}

.p-tooltip.questionnaire-step-question-locked-tooltip .p-tooltip-text {
  white-space: pre-line;
  text-align: left;
}

.questionnaire-step-lock-popover-trigger {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
  background: transparent;
  cursor: not-allowed;
}

.questionnaire-step-rich-lock-popover .p-popover-content {
  background: ${dt('primary.600')};
  border-radius: 0.375rem;
  padding: 1rem;
  width: min(25.25rem, calc(100vw - 2rem));
  max-width: min(25.25rem, calc(100vw - 2rem));
  box-shadow: ${dt('questionnaireStep.lockPopover.shadow')};
}

.questionnaire-step-rich-lock-popover {
  border: 0;
  background: transparent;
}

.questionnaire-step-rich-lock-popover .p-popover-arrow {
  width: 1rem;
  height: 1rem;
}

.questionnaire-step-rich-lock-popover .p-popover-arrow::before,
.questionnaire-step-rich-lock-popover .p-popover-arrow::after {
  border-bottom-color: ${dt('primary.600')} !important;
}

.questionnaire-step-rich-lock-popover-content {
  color: ${dt('primary.contrast.color')};
}

.questionnaire-step-rich-lock-popover-row {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
}

.questionnaire-step-rich-lock-popover-icon {
  font-size: 0.875rem;
  line-height: 1.5rem;
}

.questionnaire-step-rich-lock-popover-title {
  color: ${dt('primary.contrast.color')};
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.5rem;
}

.questionnaire-step-rich-lock-popover-detail {
  margin-top: 0.25rem;
  color: ${dt('primary.50')};
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.125rem;
}

.questionnaire-step-rich-lock-popover-actions {
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
}

.questionnaire-step-rich-lock-popover-ack {
  border: 1px solid ${dt('primary.contrast.color')};
  background: transparent;
  color: ${dt('primary.contrast.color')};
  padding: 0.5rem;
  font-size: 0.75rem;
  line-height: 1.125rem;
  cursor: pointer;
}

.questionnaire-step-legislation-select-panel .p-multiselect-option {
  align-items: flex-start;
}

.questionnaire-step-legislation-select-panel .questionnaire-step-legislation-option-text {
  color: ${dt('surface.900')};
  font-size: 1rem;
  line-height: 1.625rem;
  white-space: normal;
  word-break: break-word;
}

.questionnaire-step-sidebar-empty {
  display: flex;
  flex-direction: column;
  gap: ${dt('questionnaireStep.sidebarEmptyGap')};
  width: 100%;
  min-width: 0;
}

`;
